import { useEffect } from "react"
import { useData } from "../../../contexts/Data"
import { useModal } from "../../../contexts/Modal"
import { useCharacters } from "../../../contexts/Characters"
import { useToaster } from "../../../contexts/Toaster"
import { capitalize } from "../../../utilities/helpers"
import { useReady } from "../../../contexts/Ready"
import { Roles } from "../../../utilities/constants"
import koalition from "../../../api/koalition"
import WriteEvent from "../../modals/WriteEvent/WriteEvent"
import Event from '../../domain/Event/Event'

const Events = ({}) => {
    const modal = useModal()
    const data = useData()
    const characters = useCharacters()
    const toaster = useToaster()
    const ready = useReady()
    const eventScopes = [
        {
            name: 'server',
            writeAuthorized: characters.authorized([Roles.developer, Roles.admin])
        },
        {
            name: 'alliance',
            writeAuthorized: characters.authorized([Roles.developer, Roles.admin, Roles.leader])
        }
    ]

    const onNewEventClick = (scope) => {
        modal.open({ title: 'New Event', component: <WriteEvent />, data: { scope } })
    }
    
    const onEventClick = (scope, event) => {
        modal.open({ title: 'Edit Event', component: <WriteEvent />, data: { scope, event } })
    }

    useEffect(() => {
        if (characters.$state.current) {
            eventScopes.forEach((scope) => {
                const scopeDataKey = `${scope.name}Events`
                const scopeId = characters.$state.current?.[scope.name]?._id
                const scopeChanged = characters.$state.previous && scopeId && scopeId !== characters.$state.previous[scope.name]?._id
                const firstLoad = !characters.$state.previous && !data.$state[scopeDataKey]
                if (scopeChanged || firstLoad) {
                    data.save(scopeDataKey, [])
                    if (characters.$state.current?.[`accepted${capitalize(scope.name)}`]) {
                        koalition.get(`/events?${scope.name}=${characters.$state.current?.[scope.name]?._id}`).then((response) => {
                            data.save(scopeDataKey, response.data)
                            ready.set(scopeDataKey)
                        }).catch((error) => {
                            toaster.error(error)
                            console.error(error)
                        })
                    }
                }
            })
        }
    }, [characters.$state.current])

    return (
        <div>
            <header className="container-fluid events">
                <div className="row justify-content-end">
                    {eventScopes.map((scope) => (
                        <div className="col-lg mb-3" key={scope.name}>
                            <div className="card semi-dark">
                                <div className="row align-items-center mb-4">
                                    <h3 className="col text-center">{capitalize(scope.name)}</h3>
                                    {scope.writeAuthorized && (
                                        <div className="col-auto">
                                            <button className="primary medium icon" onClick={() => onNewEventClick(scope)}>
                                                <img src="/images/icons/plus.svg" />
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {ready.$state[`${scope.name}Events`] && <>
                                    {data.$state[`${scope.name}Events`]?.length ? (
                                        <ul>
                                            {data.$state[`${scope.name}Events`]?.map((event) => (
                                                <li className="mb-3" onClick={scope.writeAuthorized ? () => onEventClick(scope, event) : null} key={event._id}>
                                                    <Event event={event} scope={scope.name} writable={scope.writeAuthorized} />
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="text-center">No {scope.name} event has been scheduled yet</p>
                                    )}
                                </>}
                            </div>
                        </div>
                    ))}
                </div>
            </header>
        </div>
    )
}

export default Events